export const userGroupsInitialState = {
    loading: false,
    data: [],
};
